import { databaseConfig } from '../../config/database';

const API = databaseConfig.mongodb.apiBaseUrl.replace(/\/$/, '');

export async function printProductBarcodeLabel(
  accessToken: string,
  productId: string,
  options: {
    printerName: string;
    copies?: number;
    includeProductName?: boolean;
    includePriceTtc?: boolean;
  },
): Promise<{ ok: true; printer: string } | { ok: false; error: string }> {
  try {
    const res = await fetch(`${API}/api/products/${encodeURIComponent(productId)}/barcode-label/print`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        copies: options.copies ?? 1,
        includeProductName: options.includeProductName !== false,
        includePriceTtc: options.includePriceTtc !== false,
        printerName: options.printerName,
      }),
    });
    const json = (await res.json().catch(() => ({}))) as {
      data?: { printer?: string };
      message?: string;
    };
    if (!res.ok) {
      return {
        ok: false,
        error: json.message || `HTTP ${res.status}`,
      };
    }
    return { ok: true, printer: json.data?.printer || options.printerName };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : String(err),
    };
  }
}
